import React from 'react';
import classnames from 'classnames';
import Icon from 'Shared/Icon';
import Button from 'Shared/Button';
import connect from 'Shared/connect';
import { updateUserSettings } from 'Shared/UserSettings/action-creators';
import * as styles from './base.scss';
import MyMenigoIcon from '../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import { translate } from 'Shared/translate';
export const viewLayoutTypes = {
    grid: { name: 'viewLayout_Grid', icon: 'th' },
    list: { name: 'viewLayout_List', icon: 'th_list' },
    compact: { name: 'viewLayout_Compact', icon: 'nav' },
};
export class ViewLayoutSelection extends React.Component {
    constructor(props) {
        super(props);
        this.viewLayouts = Object.keys(viewLayoutTypes).map(type => viewLayoutTypes[type]).filter(type => this.props.allowedViewLayouts ? !!Array.from(this.props.allowedViewLayouts).includes(type.name) : true);
        this.inputId = () => {
            return "LayoutSelection";
        };
        this.handleClickOutside = (event) => {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                const input = document.getElementById(this.inputId());
                input.checked = false;
            }
        };
        this.getLayoutName = (name) => {
            const viewLayoutNames = {
                viewLayout_Grid: { name: translate('/Shared/LayoutOptions/Grid'), },
                viewLayout_List: { name: translate('/Shared/LayoutOptions/List') },
                viewLayout_Compact: { name: translate('/Shared/LayoutOptions/Compact') },
            };
            return !!viewLayoutNames[name] ? viewLayoutNames[name].name : name;
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    render() {
        return (React.createElement("div", { ref: e => (this.wrapperRef = e), className: classnames(styles.wrap, styles.fadeDropDown, 'ui-test-layout-buttons') },
            React.createElement("input", { style: { display: 'none' }, type: 'checkbox', id: this.inputId() }),
            React.createElement("ul", { className: styles.sortList }, this.viewLayouts.map(({ name, icon }, i) => (React.createElement("li", { key: i },
                React.createElement(Button, { className: classnames(styles.sortOptionButton), onClick: () => this.props.setViewLayoutSelection(name), appearance: "clear", key: i },
                    React.createElement("label", { htmlFor: this.inputId() },
                        this.props.viewLayoutSelection === name && (React.createElement("span", { className: styles.selectedSortOptionCheck },
                            React.createElement(Icon, { name: "check" }))),
                        this.getLayoutName(name),
                        React.createElement(Icon, { name: icon }))))))),
            React.createElement("label", { htmlFor: this.inputId(), className: styles.selectedValue },
                this.getLayoutName(this.props.viewLayoutSelection),
                React.createElement("span", null,
                    React.createElement(MyMenigoIcon, { name: "dropdownArrowDown" })))));
    }
}
export default connect(state => ({
    viewLayoutSelection: state.currentUser.userSettings.viewLayoutSelection,
}), dispatch => ({
    setViewLayoutSelection: (viewLayoutSelection) => dispatch(updateUserSettings({ viewLayoutSelection })),
}))(ViewLayoutSelection);
